/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_C2Inputs */

const en_guide_what_is_json_c2 = /** @type {(inputs: Guide_What_Is_Json_C2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why the format won over its alternatives`)
};

const ko_guide_what_is_json_c2 = /** @type {(inputs: Guide_What_Is_Json_C2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 형식이 대안들을 밀어낸 이유`)
};

const ja_guide_what_is_json_c2 = /** @type {(inputs: Guide_What_Is_Json_C2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この形式が代替を押しのけた理由`)
};

/**
* | output |
* | --- |
* | "Why the format won over its alternatives" |
*
* @param {Guide_What_Is_Json_C2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_c2 = /** @type {((inputs?: Guide_What_Is_Json_C2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_C2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_c2(inputs)
	if (locale === "ko") return ko_guide_what_is_json_c2(inputs)
	return ja_guide_what_is_json_c2(inputs)
});